export default class HintsController {
  constructor(game, hintsData, objectsData, location, state) {
    this.game = game;
    this.hintsData = hintsData;
    this.objectsData = objectsData;
    this.state = state;
    this.location = location;
    this.items = this.location.items;
    this.furnitures = this.location.furnitures;

    this.allObjects = []; // list of all objects on the screen
    this.lastLocationX = 99; // stored to check if screen was moved
    this.objectInd = 0; // index of the object which hint was displayed last time
    this.lastObjX = 0;
    this.lastObjId = '';
  }

  /* eslint-disable max-statements */
  showHint() {
    // check if location moved - then get new list of objects
    if (this.lastLocationX !== this.location.x) {
      this.lastLocationX = this.location.x;
      this.objectInd = 0;
      this.hintsToGo = -1;
    }

    this.allObjects = this.getObjectsOnScreen();

    // try to find objects which haven't hint displayed yet
    let objects = [];
    for (let i = 0; i < this.allObjects.length; i++) {
      if (!this.allObjects[i].object.hadHint) {
        objects.push(this.allObjects[i]);
      }
    }

    // if all objects on screen already displayed hint use all objects
    if (objects.length === 0) {
      objects = this.allObjects;
    } else {
      this.objectInd = 0;
    }

    // there is hint
    this.objectInd %= objects.length;

    // display 'examples' hint only
    if (this.hintsToGo < 0) {
      this.hintsToGo = Math.min(3, objects.length);
    }
    if (this.hintsToGo === 0) {
      // display hint
      this.hintsToGo = -1;
      // get hint id
      let id;
      do {
        id = Phaser.ArrayUtils.getRandomItem(this.hintsData.examples);
      } while (this.prevHintId === id);
      this.prevHintId = id;

      // select variant
      const variants = this.hintsData.examplesByID[id];
      const variant = Phaser.ArrayUtils.getRandomItem(variants);
      const cpt = this.game.cache.getJSON('vos_captions');
      const duration = cpt[id][0].end;

      //
      this.state.gameHud.btnHelp.showExample(variant, duration);
      this.displayHint(null, null, id);
    } else if (objects.length > 0) {
      this.hintsToGo--;
      const result = this.getHintFromObjects(objects);
      const { obj, hint, hintId } = result;
      this.displayHint(obj.object, hint, hintId);
      this.objectInd++;
      this.objectInd %= objects.length;
    }
  }
  /* eslint-enable */

  /* eslint-disable max-statements */
  displayHint(obj, hint, hintId) {
    // console.log(hint);

    if (hint) {
      switch (hint.action) {
        case 'pulse':
          obj.pulse();
          break;

        case 'gesture_tap': {
          let x = obj.x;
          let y = obj.y;
          let h = obj.bb.height;
          if (obj.id === 'bee_tree') {
            x += obj.button.x + obj.button.width * 0.5;
            y += obj.button.y;
            h = 0;
          }
          const gesture = this.state.showGesture(x, y - h);
          gesture.tap();
          break;
        }

        case 'gesture_slide': {
          let x = obj.x;
          let y = obj.y;
          if (obj.id === 'water_rock') {
            x += obj.parent.x;
            y += obj.parent.y;
          }

          const gesture = this.state.showGesture(x, y - obj.bb.height);
          gesture.slide(obj.id === 'lizard_rock' ? 'left' : 'right');
          break;
        }
      }
    }

    // custom reactions on target hint
    if (hintId.indexOf('target') > -1) {
      switch (hintId) {
        case 'hint_target_001': {
          // trashable
          obj.pulse();
          this.findTrashableItem().pulse();
          break;
        }
        case 'hint_target_002': {
          // composter
          obj.pulse();
          this.findCompostableItem().pulse();
          break;
        }
        case 'hint_target_006':
          // bee tree
          obj.pulse();
          break;
        case 'hint_target_008': {
          // composter
          obj.pulse();
          this.findRecyclableItem().pulse();
          break;
        }
      }
    }
    /* eslint-enable */

    // play VO
    const snd = this.game.controller.playVO(hintId);
    if (snd) {
      const soundObj = snd.get(hintId);
      soundObj.onStop.addOnce(this.onSndEnd, this);
    } else {
      this.onSndEnd();
    }
  }

  onSndEnd() {
    this.state.gameHud.btnHelp.hide();
  }

  getHintFromObjects(objects) {
    // sort objects by x
    objects = objects.sort((a, b) => b.x - a.x);

    // try to get hint for object
    const obj = objects[this.objectInd];
    const hints = obj.hints;

    // there is object with hint to display
    obj.object.hadHint = true;

    // select one of the hint
    const hintId = Phaser.ArrayUtils.getRandomItem(hints);
    const hint = this.getHintData(hintId);

    return { obj, hint, hintId };
  }

  getHintData(hintId) {
    if (hintId.indexOf('question') > -1) {
      return this.hintsData.questionsByID[hintId];
    } else if (hintId.indexOf('cta') > -1) {
      return this.hintsData.ctasByID[hintId];
    } else if (hintId.indexOf('target') > -1) {
      return this.hintsData.targetsByID[hintId];
    }

    return null;
  }

  getObjectsOnScreen() {
    const objects = [];
    const items = [];
    const left = -this.location.x + 50;
    const right = left + this.game.width - 100;

    // items
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      if (item.x > left && item.x < right) {
        items.push(item);
        const hints = this.getHintsForItem(item);
        const added = objects.find((o) => o.object.id === item.id);
        if (hints.length > 0 && !added) {
          objects.push({ object: item, type: 'i', x: item.x, hints });
        }
      }
    }

    // furnitures
    for (let i = 0; i < this.furnitures.length; i++) {
      const furniture = this.furnitures[i];
      let x = furniture.x;
      if (furniture.id === 'water_rock') {
        x += furniture.parent.x;
      }
      //
      if (x > left && x < right && !furniture.data.no_hint) {
        const hints = this.getHintsForFurniture(furniture, items);
        if (hints.length > 0) {
          objects.push({ object: furniture, type: 'f', x: x, hints });
        }
      }
    }

    return objects;
  }

  getHintsForItem(item) {
    const hints = [];

    // check questions
    for (let i = 0; i < this.hintsData.questions.length; i++) {
      const questionID = this.hintsData.questions[i];
      const question = this.hintsData.questionsByID[questionID];
      if (this.isHintForItem(question, item)) {
        hints.push(questionID);
      }
    }

    // check ctas
    for (let i = 0; i < this.hintsData.ctas.length; i++) {
      const ctaID = this.hintsData.ctas[i];
      const cta = this.hintsData.ctasByID[ctaID];
      if (this.isHintForItem(cta, item)) {
        hints.push(ctaID);
      }
    }

    return hints;
  }

  isHintForItem(hint, item) {
    if (
      hint.device &&
      ((hint.device === 'desktop' && this.game.deviceMetric.platform.type !== 'desktop') ||
        (hint.device === 'mobile' && this.game.deviceMetric.platform.type === 'desktop'))
    ) {
      return false;
    }

    if (hint.items) {
      if (hint.items.indexOf(item.id) > -1) {
        return true;
      }
      if (hint.items.indexOf('[SPAWN]') > -1 && item.spawn) {
        return true;
      }
      if (hint.items.indexOf('[FOOD]') > -1 && item.canBeEaten()) {
        return true;
      }
      if (hint.items.indexOf('[TRASHABLE]') > -1 && item.canBeTrashed()) {
        return true;
      }
      if (hint.items.indexOf('[RECYCLABLE]') > -1 && item.isRecyclable()) {
        return true;
      }
      if (hint.items.indexOf('[COMPOSTABLE]') > -1 && item.canBeComposted()) {
        return true;
      }
      return false;
    } else if (hint.items_exceptions) {
      if (hint.items_exceptions.indexOf(item.id) > -1) {
        return false;
      }
      if (hint.items_exceptions.indexOf('[FOOD]') > -1 && item.canBeEaten()) {
        return false;
      }
      return true;
    }

    return false;
  }

  getHintsForFurniture(furniture, items) {
    const hints = [];

    // check questions
    for (let i = 0; i < this.hintsData.questions.length; i++) {
      const questionID = this.hintsData.questions[i];
      const question = this.hintsData.questionsByID[questionID];
      if (this.isHintForFurniture(question, furniture)) {
        hints.push(questionID);
      }
    }

    // check ctas
    for (let i = 0; i < this.hintsData.ctas.length; i++) {
      const ctaID = this.hintsData.ctas[i];
      const cta = this.hintsData.ctasByID[ctaID];
      if (this.isHintForFurniture(cta, furniture)) {
        hints.push(ctaID);
      }
    }

    // check targeted
    for (let i = 0; i < this.hintsData.targets.length; i++) {
      const targetID = this.hintsData.targets[i];
      const target = this.hintsData.targetsByID[targetID];
      if (this.isTargetHint(target, furniture, items)) {
        hints.push(targetID);
      }
    }

    return hints;
  }

  isHintForFurniture(hint, furniture) {
    if (
      hint.device &&
      ((hint.device === 'desktop' && this.game.deviceMetric.platform.type !== 'desktop') ||
        (hint.device === 'mobile' && this.game.deviceMetric.platform.type === 'desktop'))
    ) {
      return false;
    }

    //
    if (hint.furnitures.indexOf(furniture.id) > -1) {
      return true;
    }
    if (hint.furnitures.indexOf('[MACRO_VIEW]') > -1 && furniture.magnifierIcon) {
      return true;
    }

    return false;
  }

  isTargetHint(hint, furniture, items) {
    if (hint.furnitures.indexOf(furniture.id) > -1) {
      // check other special conditions
      if (hint.items.length > 0) {
        if (hint.items.indexOf('[TRASHABLE]') > -1) {
          // check if there is at least 1 trashable item on screen
          for (let i = 0; i < items.length; i++) {
            if (items[i].canBeTrashed()) return true;
          }
        } else if (hint.items.indexOf('[COMPOSTABLE]') > -1) {
          // check if there is at least 1 compostable item on screen
          for (let i = 0; i < items.length; i++) {
            if (items[i].canBeComposted()) return true;
          }
        } else if (hint.items.indexOf('[RECYCLABLE]') > -1) {
          // check if there is at least 1 recyclable item on screen
          for (let i = 0; i < items.length; i++) {
            if (items[i].isRecyclable()) return true;
          }
        }
      } else {
        // no special condition - return true
        return true;
      }
    }

    return false;
  }

  findCompostableItem() {
    const items = [];
    for (let i = 0; i < this.allObjects.length; i++) {
      const obj = this.allObjects[i];
      if (obj.type === 'i' && obj.object.canBeComposted()) {
        items.push(obj.object);
      }
    }

    return Phaser.ArrayUtils.getRandomItem(items);
  }

  findTrashableItem() {
    const items = [];
    for (let i = 0; i < this.allObjects.length; i++) {
      const obj = this.allObjects[i];
      if (obj.type === 'i' && obj.object.canBeTrashed()) {
        items.push(obj.object);
      }
    }

    return Phaser.ArrayUtils.getRandomItem(items);
  }

  findRecyclableItem() {
    const items = [];
    for (let i = 0; i < this.allObjects.length; i++) {
      const obj = this.allObjects[i];
      if (obj.type === 'i' && obj.object.isRecyclable()) {
        items.push(obj.object);
      }
    }

    return Phaser.ArrayUtils.getRandomItem(items);
  }
}
